// @flow
import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { screen } from '../lib/utils';

export const StyledInput = styled.label`
  display: block;
  font-weight: bold;
  border: 3px solid ${({ theme }) => theme.colors.inputBorder};
  position: relative;
  width: 100%;

  .label,
  .error-message {
    text-transform: uppercase;
    font-size: 1.25rem;
    line-height: 1.5rem;
    position: absolute;
    top: 0;
    left: 0;
    padding: calc(1.5rem - 3px) 1.5rem calc(1.5rem - 5px);
    transition: all ${({ theme }) => theme.animation.default};
  }

  .label {
    color: ${({ theme }) => theme.colors.gray};
  }

  .error-message {
    display: none;
    color: ${({ theme }) => theme.colors.red};
  }

  input {
    color: ${({ theme }) => theme.colors.text};
    background-color: ${({ theme }) => theme.colors.pageBg};
    width: 100%;
    font-size: 1.25rem;
    padding: 2rem 1.5rem calc(1rem - 8px);
    border: none;
    margin: 0;
    appearance: none;
    transition: all ${({ theme }) => theme.animation.default};
    text-transform: uppercase;

    /* ${screen.atLeast.tablet`
      font-size: 1.125rem;
      padding: 1.25rem;
    `} */

    &:focus {
      outline: none;
      background-color: ${({ theme }) => theme.colors.lightBlue};
    }
  }

  input:focus + .label,
  .label.not-empty,
  .error-message {
    font-size: 0.875rem;
    transform: translate3d(0, -14px, 0);
  }

  ${({ error }) =>
    error &&
    css`
      border-color: ${({ theme }) => theme.colors.red};

      .error-message {
        display: block;
      }

      .label {
        font-size: 1.25rem !important;
        padding: 2rem 1.5rem calc(1rem - 8px);
        transform: translate3d(0, 0, 0) !important;

        &.not-empty {
          display: none;
        }
      }

      input:focus {
        background-color: ${({ theme }) => theme.colors.lightRed};
      }
    `};
`;

type AsFormInputPropsType = {
  label: string,
  name: string,
  value: string,
  type?: string,
  width: number,
  onChange: (
    event: SyntheticInputEvent<HTMLInputElement>,
    shouldRevalidate: boolean,
  ) => void,
  onBlur: () => void,
  error: string,
  hadSubmit?: boolean,
};

const AsFormInput = ({
  label,
  name,
  value,
  type,
  width,
  onChange,
  onBlur,
  error,
  hadSubmit,
}: AsFormInputPropsType) => {
  const [hadValue, setHadValue] = useState(false);
  const showError = hadValue && error;
  useEffect(() => {
    if (hadSubmit) setHadValue(true);
  }, [hadSubmit]);
  return (
    <StyledInput w={width} htmlFor={`as-form__${name}`} error={showError}>
      <input
        id={`as-form__${name}`}
        name={name}
        value={value}
        type={type}
        onChange={(event) => {
          const shouldRevalidate = hadValue && !!error;
          onChange(event, shouldRevalidate);
        }}
        onBlur={() => {
          setHadValue(true);
          onBlur();
        }}
      />
      <span className={`label ${value === '' ? 'empty' : 'not-empty'}`}>
        {label}
      </span>
      <span className={`error-message ${showError ? 'show' : 'hide'}`}>
        {error}
      </span>
    </StyledInput>
  );
};
AsFormInput.defaultProps = {
  type: 'text',
  hadSubmit: false,
};

export default AsFormInput;
